module.exports = __webpack_public_path__ + "fonts/65cbb1b9/proximanova-regularit-webfont.woff2";